import smartWebsocket from './smartWebsocket';
import createWebsocketMiddleware from './socketMiddleware';

export default {
	smartWebsocket,
	createWebsocketMiddleware,
};
